<template>
  <div>
    <BasiceLayout :title="$t('title')">
      <div class="hardware-content">
        <!-- mac地址搜索 -->
        <div
          class="hardware-search-wrap"
          align='center'
        >
          <span class="search-text">{{$t('mac_address')}}</span>
          <el-input
            class="search-mac-input"
            v-model="searchMacAddress"
            placeholder=""
            @change="search('mac', searchMacAddress)"
          ></el-input>
          <span class="search-text">{{$t('noteSearch')}}</span>
          <el-input
            class="search-mac-input"
            v-model="searchNote"
            @change="search('note', searchNote)"
          ></el-input>
          <span class="search-text">{{$t('errorDevice')}}</span>
          <el-select
            v-model="filterType"
            filterable
            placeholder=""
            @change="getErrorDevices"
          >
            <el-option
              v-for="item in errorType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div
            class="button export-button"
            @click="exportList(1, 200, [])"
          >{{ $t('export') }}</div>
        </div>
        <!-- 硬件列表 -->
        <el-table
          v-if="hardList !== 'NO_CONTENT'"
          :data="hardList"
          align="left"
          empty-text="Loading..."
          style="width: 100%"
          @sort-change="sortDevices"
        >
          <!-- mac address -->
          <el-table-column
            prop="mac_address"
            :label="$t('mac_address')"
            align='center'
          >
          </el-table-column>
          <!-- 备注 -->
          <el-table-column
            :label="$t('noteText')"
            align='center'
            sortable="custom"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.note">{{scope.row.note}}</div>
              <div
                v-if="!scope.row.note"
                :deviceId="scope.row.deviceId"
                @click="showNotes(scope.row.id, scope.row.mac_address)"
                class="add-note-button button bonus-cursor"
              >
                {{$t('addNote')}}</div>
              <i
                v-if="scope.row.note && scope.row.noteStatus"
                class="el-icon-edit"
                @click="showNotes(scope.row.id, scope.row.mac_address)"
              ></i>
            </template>
          </el-table-column>
          <!-- IP -->
          <el-table-column
            prop=""
            label="IP"
            align='center'
            v-if="filterType !== 'NoMonitor'"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.ext_ip">-</div>
              <div v-if="scope.row.ext_ip">{{scope.row.ext_ip}}</div>
            </template>
          </el-table-column>
          <!-- 内存 -->
          <el-table-column
            prop=""
            :label="$t('mem_size')"
            align='center'
          >
            <template slot-scope="scope">
              <div v-if="scope.row.mem_size">{{scope.row.mem_size}}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <!-- 硬盘 -->
          <el-table-column
            prop=""
            :label="$t('storage_size')"
            align='center'
          >
            <template slot-scope="scope">
              <div v-if="scope.row.storage_size">{{scope.row.storage_size}}</div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <!-- 节点网络质量 -->
          <el-table-column
            prop=""
            :label="$t('node_stability')"
            align='center'
            :render-header="renderHeader"
            width="140px"
            v-if="filterType !== 'NoMonitor'"
          >
            <template slot-scope="scope">
              <!-- 5、5-10、10-20、20 -->
              <el-tag
                v-if="scope.row.stableValue > 2500 || scope.row.stableValue === 0"
                type="danger"
              >{{$t('low')}}</el-tag>
              <el-tag
                v-if="scope.row.stableValue < 1000 && scope.row.stableValue > 0"
                type="success"
              >{{$t('high')}}</el-tag>
              <el-tag
                v-if="scope.row.stableValue <= 2500 && scope.row.stableValue >= 1000"
                type="warning"
              >{{$t('medium')}}</el-tag>
            </template>
          </el-table-column>
          <!-- 地区 -->
          <!-- <el-table-column prop="location" :label="$t('location')" align='center'></el-table-column> -->
          <!-- 网络资源可用性 -->
          <el-table-column
            prop=""
            :label="$t('stable')"
            align='center'
            :render-header="renderHeader"
            width="140px"
            v-if="filterType !== 'NoMonitor'"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.stableValue">-</div>
              <el-tag
                v-if="scope.row.stableValue < 2500 && scope.row.stableValue > 0"
                type="success"
              >{{$t('stableUseful')}}</el-tag>
              <el-tag
                v-if="scope.row.stableValue >= 2500"
                type="danger"
              >{{$t('stableDisabled')}}</el-tag>
            </template>
          </el-table-column>
          <!-- 是否可被调度 -->
          <el-table-column
            prop=""
            :label="$t('schedule')"
            align='center'
            :render-header="renderHeader"
            width="140px"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.schedule"
                type="success"
              >{{$t('scheduleSuccess')}}</el-tag>
              <el-tag
                v-if="!scope.row.schedule"
                type="danger"
              >{{$t('scheduleFalse')}}</el-tag>
            </template>
          </el-table-column>
          <!-- 在线状态 -->
          <el-table-column
            prop=""
            :label="$t('netStatus')"
            align='center'
            v-if="filterType !== 'NoMonitor'"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.status">-</div>
              <el-tag
                v-if="scope.row.status === 'online'"
                type="success"
              >online</el-tag>
              <el-tag
                v-if="scope.row.status === 'offline'"
                type="danger"
              >offline</el-tag>
            </template>
          </el-table-column>
          <!-- 监测 -->
          <el-table-column
            prop=""
            :label="$t('watch')"
            align='center'
          >
            <template slot-scope="scope">
              <img
                class="watch-icon"
                @click="showWatchDetail('id', scope.row.id, scope.row.info)"
                src="../../assets/hardList/watch.png"
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          class="pagination"
          v-if="deviceSize > 1"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="deviceSize"
            layout="total, prev, pager, next"
            :total="hardLength"
          >
          </el-pagination>
        </div>
        <el-table
          v-if="hardList === 'NO_CONTENT'"
          :empty-text="$t('noHardwareTip')"
          style="width: 100%"
        >
        </el-table>
      </div>
    </BasiceLayout>
    <!-- 监控 -->
    <el-dialog
      :title="$t('watchDetail.title')"
      :visible.sync="showWatchDialog"
      width="60%"
      center
    >
      <div class="watch-dialog-wrap">
        <span class="key"></span>
        <div class="watch-select">
          <span class="search-text">{{$t('watchDetail.watchDate')}}:</span>
          <el-select
            v-model="searchWatchDate"
            filterable
            placeholder=""
            @change="showWatchDetail"
          >
            <el-option
              v-for="item in queryDate"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="showCharts || showUseBandCharts">
          <ve-line
            v-if="showCharts"
            class="watch-chart"
            :data="stableCharts"
          ></ve-line>
          <ve-line
            v-if="showCharts"
            class="watch-chart"
            :data="availabilityChart"
          ></ve-line>
          <ve-line
            v-if="showCharts"
            class="watch-chart"
            :data="hardOnlineChart"
          ></ve-line>
          <!-- <ve-line
            class="watch-chart"
            :data="txBwCharts"
          ></ve-line> -->
          <ve-line
            v-if="showUseBandCharts"
            class="watch-chart"
            :data="useBandCharts"
          ></ve-line>
        </div>
      </div>
      <div
        v-if="!showCharts && !showUseBandCharts"
        class="no-watch-data"
      >{{$t('watchDetail.noData')}}</div>
    </el-dialog>
    <!-- 增加备注 -->
    <el-dialog
      :title="$t('addNotes.title')"
      :visible.sync="showAddnoteDialog"
      width="480px"
      center
    >
      <div class="addnote-dialog-wrap">
        <span class="key">{{$t('addNotes.tipText')}}({{addNoteAddress}})</span>
        <input
          type="text"
          class="basic-input input addnote-input"
          v-model="addNoteInput"
        >
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          @click="showAddnoteDialog = false"
        >{{ $t('cancel') }}</div>
        <div
          class="sure-unbind button"
          type="primary"
          @click="addNote"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import RevenueContent from "@/components/DatePanel/RevenueContent.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { BytesToM, toFixed } from "@/utils/utils";
import { getCookie } from "@/utils/utils";
import { Loading } from "element-ui";
import { Message } from "element-ui";

export default {
  name: "BonusCode",
  components: {
    BasiceLayout
  },
  data() {
    return {
      showAddnoteDialog: false, //添加备注
      addNoteInput: "",
      addNoteId: "", //添加备注Id
      addNoteAddress: "", //添加备注Id
      searchNote: "",
      searchMacAddress: "",
      showWatchDialog: false, //监控弹框
      showUseBandCharts: false,
      useBandInfo: '',
      useBandDeviceId: '',
      searchType: '',
      useBandCharts: {},
      deviceOrder: 'note', //默认使用备注排序
      errorType: [{
        value: 'all',
        label:  this.$t("type.all"),
      },
      {
        value: 'networkNormal',
        label:  this.$t("type.networkNormal"),
      },
      {
        value: 'calculateNormal',
        label:  this.$t("type.calculateNormal"),
      },
      {
        value: 'offline',
        label: this.$t("type.offline"),
      },
      {
        value: 'usableNet',
        label: this.$t("type.usableNet"),
      },
      {
        value: 'unschedule',
        label: this.$t("type.unschedule"),
      },
      {
        value: 'lowMem',
        label: this.$t("type.lowMem"),
      },
      {
        value: 'lowStorage',
        label: this.$t("type.lowStorage"),
      },
      {
        value: 'unTask',
        label: this.$t("type.unTask"),
      },
      {
        value: 'NoMonitor',
        label: this.$t("type.NoMonitor"),
      }],
      showCharts: "waiting",
      searchWatchDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      stableCharts: {},
      availabilityChart: {},
      hardOnlineChart: {},
    };
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,

    // overview: state => state.device.overview || ""
    hardList(state) {
      if (state.hardWare.list && !!state.hardWare.list.length && state.hardWare.list !== 'NO_CONTENT') {
        return this.dealScheduleError(state.hardWare.list);
      } else {
        return state.hardWare.list;
      }
    },
    deviceSize: state => state.hardWare.deviceSize,
    hardLength: state => state.hardWare.hardLength,
    currentPage: state => state.hardWare.currentPage,
    filterType: state => state.device.filterType,
    queryDate: () => {
      let queryDate = [];
      let endDay = moment()
        .utc()
        .startOf("day");

      endDay -= 24 * 60 * 60 * 1000;
      let i = 0;
      while (i < 7) {
        i++;
        queryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }

      return queryDate;
    }
  }),
  created() {
    this.getHardList({ pageNum: 1 });
  },

  methods: {
    ...mapActions(["getHardList", "getDeviceWatchDetail", "getDeviceDetail", "setFiltertype", "getDevicePcdnFlow", "addDeviceNotes" ]),
    // schedule error
    dealScheduleError(list) {
      if (!list || !list.length) {
        return [];
      }

      return list.map(item => {

        if (item.task_solution === 'system') {
          item.scheduleError = !this.isZnWebsite ?'Automatically repairing, waiting for rescheduling.' : '自动修复中，等待重新调度。';
        } else if (item.task_solution === 'network_check') {
          item.scheduleError = !this.isZnWebsite ? 'Network failure, please check the network.' : '网络故障，请检查网络。';
        } else if (item.task_solution === 'os_rebuild') {
          item.scheduleError = !this.isZnWebsite ? 'System failure, please flash again.' : '系统故障，请重新刷机。';
        } else if (item.task_solution === 'hd_format') {
          item.scheduleError = !this.isZnWebsite ? 'The hard disk is faulty. Please format the hard disk to ext4 format.' : '硬盘故障，请格式化硬盘为ext4格式。';
        } else {
          item.scheduleError = !this.isZnWebsite ? 'The question is pending, please join the group to contact the official staff.' : '问题待定，请前往微信“博纳云”工单小程序提交工单反馈。';
        }
        return item;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      let filterType = this.filterType;
      let deviceOrder = this.deviceOrder;

      this.getHardList({ pageNum: val, filterType, deviceOrder });
    },
    // 备注
    showNotes(id, address) {
      this.showAddnoteDialog = true;
      this.addNoteId = id;
      this.addNoteAddress = address;
    },
    // 添加备注
    addNote() {
      let that = this;
      if (!this.addNoteInput) {
        return;
      }
      this.addDeviceNotes({
        deviceId: this.addNoteId,
        note: this.addNoteInput
      }).then(res => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message
          });
          that.showAddnoteDialog = false;
          that.getHardList({
            pageNum: that.currentPage
          });
        } else {
          Message({
            type: "error",
            message: res.message || "add note error"
          });
        }
      });
    },
    // 搜索
    search(type, value) {
      if (type === 'mac') {
        this.getDeviceDetail({ macAddress: value });
      } else {
        this.getDeviceDetail({ note: value});
      }
    },
    // 排序
    sortDevices() {
      let { filterType, currentPage } = this;
      let deviceOrder = 'note';
      this.deviceOrder = deviceOrder;
      this.getHardList({ filterType, pageNum: currentPage, deviceOrder});
    },
    renderHeader: function(creatElement, { column, $index }) {
      let fields = this.fields;
      return creatElement("div", [
        column.label,
        creatElement(
          "el-tooltip",
          {
            class: "cell-s-tip",
            props: {
              content: (function() {
                let label = column.label;
                switch (label) {
                  case "是否已被调度":
                    return "已调度的设备需要3-4天同步数据后才能稳定运行，请保持设备在线；调度失败的设备需要将硬盘重新格式化后再插入并等待重新调度。";
                    break;
                  case "Scheduling Status":
                    return "Since it takes 3 - 4 days for the scheduled devices to run in a stable status after the data synchronization, please keep the devices online. Please reformat the hard drive of the devices that fail to be scheduled and insert it again to await for the rescheduling.";
                    break;
                  case "节点网络质量":
                    return "节点网络质量表示当前设备的网络稳定情况，掉线、延迟、丢包等网络情况都会导致网络质量变差，网络质量出现波动后，需要1小时逐步恢复。";
                    break;
                  case "Node Stability":
                    return "The node network quality refers to the network stability of the corresponding device, and the situations, such as disconnection, time delay and packet loss, affect the network quality. It will take 1 hour for the gradual recovery after the fluctuation of the network quality occuring.";
                    break;
                  case "网络资源可用性":
                    return "网络资源可用时才可以获得网络任务收益，可用性受节点网络质量影响，当网络质量为低时，网络资源不可用，无法获得网络任务收益。";
                    break;
                  case "Network Resource Availability":
                    return "The network task revenue can be obtained when network resource is available, and the availability is influenced by the the node network quality. If the quality is low, the network resource will be in status of 'not available', and no network task revenue will be released.";
                    break;
                  case "计算任务调度":
                    return "是否可被调度表示设备是否正常连接到计算任务调度服务器，若该状态为否，则会导致设备无法正常运行计算任务，需要排查DNS解析是否有误。";
                    break;
                  case "Computing Task Scheduling":
                    return `The schedulability refers to the status of the device connected into the computing task scheduling server. If the status is "not schedulable", it means that the corresponding device cannot run computing task normally, please check whether DNS is resolved correctly.`;
                    break;
                }
              })(),
              effect: "dark",
              placement: "top"
            }
          },
          [
            creatElement("i", {
              class: "fa fa-question-circle revenue-icon el-icon-question"
            })
          ]
        )
      ]);
    },
    getErrorDevices(filterType) {
      this.setFiltertype(filterType);
      this.deviceOrder = '';
      this.getHardList({ filterType, pageNum: 1 });
    },
    // 显示监控
    showWatchDetail(type, id, info) {
      let that = this;
      this.showWatchDialog = true;
      this.watchId = type === "id" ? id : this.watchId;
      let queryDate = this.searchWatchDate;
      let date_after = moment(queryDate).utc().valueOf(),
        date_before = date_after + 86400000;

      let watchStable = this.$t("watchDetail.watchStable");
      let watchAvaliable = this.$t("watchDetail.watchAvaliable");
      let watchStorge = this.$t("watchDetail.watchStorge");
      let watchBandwith = this.$t("watchDetail.watchBandwith");

      // 处理参数
      if (id) {
        that.useBandInfo = info;
        that.useBandDeviceId = id;
      } else {
        info = this.useBandInfo;
        id = this.useBandDeviceId;
      }

      let watchDate = this.$t("watchDetail.watchDate");

      this.getDeviceWatchDetail({
        id: this.watchId,
        queryDate
      }).then(res => {
        if (res && res.length) {
          // 此处为了中英文对照，所以动态处理
          let stableCharts = {
              columns: [],
              rows: []
            },
            availabilityChart = {
              columns: [],
              rows: []
            },
            hardOnlineChart = {
              columns: [],
              rows: []
            };

          let stableColumns = [],
            availabilityColumns = [],
            hardOnlineColumns = [],
            txBwColumns = [];
          stableColumns.push(watchDate);
          stableColumns.push(watchStable);
          stableCharts.columns = stableColumns;

          availabilityColumns.push(watchDate);
          availabilityColumns.push(watchAvaliable);
          availabilityChart.columns = availabilityColumns;

          hardOnlineColumns.push(watchDate);
          hardOnlineColumns.push(watchStorge);
          hardOnlineChart.columns = hardOnlineColumns;


          res.map(item => {
            let { time, stable, ext_storage_size, tx_bandwidth } = item;
            let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");

            let stableRows = [],
              availabilityRows = [],
              hardOnlineRows = [],
              txBwRows = [];
            // 日期处理
            (stableRows[watchDate] = date_at),
              (availabilityRows[watchDate] = date_at),
              (hardOnlineRows[watchDate] = date_at),

            stableRows[watchStable] = stable;
            availabilityRows[watchAvaliable] =
              stable < 2500 && stable > 0 ? 100 : 0;
            hardOnlineRows[watchStorge] = (
              Number(ext_storage_size) /
              1024 /
              1024 /
              1024
            ).toFixed(2);


            stableCharts.rows.push(stableRows);
            availabilityChart.rows.push(availabilityRows);
            hardOnlineChart.rows.push(hardOnlineRows);
          });

          that.showCharts = true;
          that.stableCharts = stableCharts;
          that.availabilityChart = availabilityChart;
          that.hardOnlineChart = hardOnlineChart;
        } else {
          that.showCharts = false;
        }
      });

      // 查询设备实际带宽
      this.getDevicePcdnFlow({
        info,
        device_id: id,
        flow_user: "total",
        date_before,
        date_after
      }).then(res => {
        that.useBandInfo = info;
        that.useBandDeviceId = id;

        if (res && res.device_pcdnflow_logging && res.device_pcdnflow_logging.length) {
           // 判断是否dcache设备
          let isDcache = false;
          res.flow_users.map(item => {
            if (item.user_name === 'dcache') {
              isDcache = true;
            }
          })

          // 此处为了中英文对照，所以动态处理
          let useBandCharts = {
            columns: [],
            rows: []
          };

          useBandCharts.columns = [
            watchDate,
            watchBandwith,
          ];

          res.device_pcdnflow_logging.map(item => {
            let { time, diffBps, out_bps } = item;
            let value = isDcache ? diffBps : out_bps;
            let date_at = moment(new Date(time))
              .utc()
              .format("YYYY-MM-DD HH:mm:ss");

            let useBandRows = [];
            // 日期处理
            useBandRows[watchDate] = date_at;
            useBandRows[watchBandwith] = toFixed(
              BytesToM(value)
            );
            useBandCharts.rows.push(useBandRows);
          });

          that.useBandCharts = useBandCharts;
          that.showUseBandCharts = true;
        } else {
          that.showUseBandCharts = false;
        }
      });
    },
    // 导出硬件列表
    exportList(pageNum, pageSize, hardList = []) {
      const that = this;
      let filterType = this.filterType;
      let deviceOrder = this.deviceOrder;
      (pageSize = pageSize || 200);
      (pageNum = pageNum || 1);
      let loadingInstance = Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.8)' });

      this.getHardList({ pageNum, pageSize, GETRESULT: 'true', filterType , deviceOrder}).then(result => {
        if (result) {
          let length = result.deviceLength;
          hardList = hardList.concat(result.list);

          if (hardList.length === length) {
            import("@/vendor/Export2Excel").then(excel => {
              const tHeader = that.$t("excelHeaders").split("&");
              const filterVal = [
                "mac_address",
                "note",
                "ext_ip",
                "mem_size",
                "storage_size",
                "stableQa",
                "stableUseable",
                "schedule",
                "task_status",
                "status"
              ];
              const list = hardList;
              const data = list.map(v => filterVal.map(j => {
                // 处理节点网络质量
                if (j === 'stableQa') {
                  if (v.stableValue > 2500 || v.stableValue === 0) {
                    return that.$t('low');
                  } else if(v.stableValue < 1000 && v.stableValue > 0) {
                    return that.$t('high');
                  } else if(v.stableValue <= 2500 && v.stableValue >= 1000) {
                    return that.$t('medium');
                  }
                }
                // 网络资源可用性
                if (j === 'stableUseable') {
                  if (v.stableValue < 2500 && v.stableValue > 0) {
                    return that.$t('stableUseful');
                  } else {
                    return that.$t('stableDisabled');
                  }
                 }
                //  调度状态
                if (j === 'schedule') {
                  return v[j] ? that.$t('scheduleSuccess') : that.$t('scheduleFalse')
                }

                return v[j];
              }));

              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "hardlist",
                autoWidth: true,
                bookType: "xlsx"
              });
              // 关闭loading
              loadingInstance.close();
            });
          } else {
            that.exportList(pageNum + 1, pageSize, hardList);
          }
        } else {
          loadingInstance.close();
        }
      });
    }
  }
};
</script>

<i18n>
{
  "en": {
    "noteSearch": "Note",
    "title": "Device Detail",
    "errorDevice": "Error Device",
    "type": {
      "all": "All",
      "offline": "Offline device",
      "networkNormal": "Network normal",
      "calculateNormal": "Network normal",
      "usableNet": "Network usable",
      "unschedule": "Scheduling failed",
      "lowMem": "Storage less than 100G",
      "lowStorage": "Memory less than 1G",
      "unTask": "Compute no scheduled",
      "NoMonitor": "无带宽数据"
    },
    "excelHeaders": "Mac Address&Note&IP&Memory&Storage&Node Stablity&Network Resource Availability&Computing Task Scheduling&Scheduling Status&Status"
  },
  "zn": {
    "noteSearch": "备注",
    "title": "设备详情",
    "errorDevice": "异常设备",
    "type": {
      "all": "全部",
      "networkNormal": "网络任务正常设备数",
      "calculateNormal": "计算任务正常设备数",
      "offline": "离线设备",
      "usableNet": "网络资源不可用",
      "unschedule": "计算任务资源不可调度",
      "lowMem": "内存小于1G",
      "lowStorage": "硬盘小于100G",
      "unTask": "调度失败",
      "NoMonitor": "无带宽数据"
    },
    "excelHeaders": "Mac地址&备注&IP&内存&硬盘&节点网络质量&网络资源可用&计算任务调度&是否已被调度&在线状态"
  }
}
</i18n>

<style>
.export-button {
  float: right;
}
</style>


